import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Container } from 'reactstrap';
import PageHeader from 'shared/components/PageHeader';
import { PageNames } from 'shared/constants/appConstants';
import Panel from 'shared/components/Panel';
import ChartsPanel from 'kubernetes/containers/KubernetesDashboard/components/ChartsPanel/ChartsPanel';
import K8SCostBreakdown from 'kubernetes/containers/KubernetesDashboard/components/K8SCostBreakdown/K8SCostBreakdown';
import checkFeatureFlag from 'shared/utils/featureFlagUtil';
import { Routes } from 'shared/constants/routes';
import { ACCOUNT_FEATURES } from 'users/constants/usersConstants';

const K8ScostAndUsagePage = observer(
  ({ invoiceStore, kubernetesStore, usersStore, appStore, usageStore, isPpApplied, location, navigate }) => {
    const isK8sEnabled = checkFeatureFlag(usersStore, ACCOUNT_FEATURES.K8S);
    useEffect(() => {
      if (!isK8sEnabled) {
        navigate(Routes.K8S_PREVIEW);
      }
    }, [isK8sEnabled, navigate]);
    return (
      <Container>
        <PageHeader title={PageNames.K8S_USAGE} showDate />
        <ChartsPanel
          usageStore={usageStore}
          location={location}
          appStore={appStore}
          usersStore={usersStore}
          kubernetesStore={kubernetesStore} // todo - remove
          invoiceStore={invoiceStore}
          navigate={navigate}
          isPpApplied={isPpApplied}
        />
        <Panel divider title="COST BREAKDOWN" isColPaddingZero>
          <K8SCostBreakdown />
        </Panel>
      </Container>
    );
  },
);

export default K8ScostAndUsagePage;
